import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ReconcileSession,
  type ReconcileSessionConstructor,
} from './ReconcileSession'
import { ReconcileSessionStatuses } from '../enums/ReconcileSessionStatusEnum'
import { SessionLockStatusConstructorFactory } from '../SessionLockStatus'

export const ReconcileSessionConstructorFactory =
  Factory.Sync.makeFactory<ReconcileSessionConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    status: ReconcileSessionStatuses.DRAFT,
    balance: Factory.each(() => faker.finance.amount()),
    statementDate: '2024-01-31',
    lockStatus: Factory.each(() => SessionLockStatusConstructorFactory.build()),
    billUuid: null,
    billGroup: null,
    creditcardId: Factory.each(() => faker.random.number()),
  })

export const ReconcileSessionFactory = EntityFactory(
  ReconcileSession,
  ReconcileSessionConstructorFactory
)
